export default function SearchStatus() {
    return {
        restrict: "E",
        scope: {},
        template: require("./search-status.html"),

        controller: function ($scope, $rootScope, houseService) {
            $scope.searchFilter = houseService.searchFilter;

            // $scope.headerHeight = siteService.headerHeight;

            // when user changes the date ( datepicker.js )
            var syncSearchbarEventListener = $scope.$on(
                "sync-searchbar-broadcast",
                function () {
                    //avail params : event, house
                    //$scope.searchFilter = houseService.searchFilter
                }
            );
            $scope.$on("$destroy", syncSearchbarEventListener);

            /**
             * activateSearchBarInput
             *
             * when clicked, open the wanted search Bar input
             *
             * @param  int      searchInputIndex  [index of wanted Searchbar Input - Look at SearchBarFactory]
             * @param  string   oSearchName       [deprecated]
             * @return void
             */
            $scope.activateSearchBarInput = function (oSearchInputIndex) {
                // OPEN DROPDOWN IN SEARCHBAR
                $rootScope.$broadcast(
                    "activate-searchbar-dropdown-broadcast",
                    oSearchInputIndex
                );
            };
        },
    };
}
